module.exports = __webpack_public_path__ + "static/19-3-67d532d8fb4baa9352ca8436919377b5.jpg";